// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 225) return "static/chunks/225.d963f2ff1e68ce9e.js";
	if (chunkId === 627) return "static/chunks/627.582d432daf7365c5.js";
	if (chunkId === 8) return "static/chunks/8.582d432daf7365c5.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 251 ? "11d73c47" : chunkId) + "-" + {"51":"192b217cfdc5c149","251":"5e44437c42b262a1","478":"3e00afc3aeacbd44","873":"716c79a41d6820b5","878":"2e7d57b4f0d42a45","922":"fdfdd083440dd76c"}[chunkId] + ".js";
};